module.exports = __webpack_public_path__ + "static/img/27-Everyday-money-GettyImages-1159969537.775f15d3.jpg";